import { h, defineComponent, ref, onMounted, watch, nextTick, onBeforeUnmount } from 'vue';
import { renderPdfCanvasPreview } from './pdf-canvas-renderer.js';
import { sanitizeRichText } from './sanitize-rich-text.js';
const GUID_PATTERN = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;
export const RichText = defineComponent({
    name: 'RichText',
    props: {
        html: {
            type: String,
            default: '',
        },
        as: {
            type: String,
            default: 'div',
        },
        previewToken: {
            type: String,
            default: null,
        },
        pdfCacheVersion: {
            type: String,
            default: null,
        },
    },
    setup(props) {
        const rootRef = ref(null);
        const previews = createPdfPreviewController(props, rootRef);
        onMounted(() => {
            previews.render();
        });
        watch(() => [props.html, props.previewToken, props.pdfCacheVersion], () => {
            void nextTick(() => {
                previews.render();
            });
        });
        onBeforeUnmount(() => {
            previews.cancel();
        });
        return () => h(props.as ?? 'div', {
            ref: rootRef,
            class: 'rich-text',
            innerHTML: sanitizeRichText(props.html),
        });
    },
});
function createPdfPreviewController(props, rootRef) {
    const canvasPreviews = new Set();
    const disposeCanvasPreviews = () => {
        canvasPreviews.forEach((preview) => preview.dispose());
        canvasPreviews.clear();
    };
    const render = () => {
        const placeholders = rootRef.value?.querySelectorAll('.pdf-inline-preview');
        disposeCanvasPreviews();
        if (!placeholders?.length) {
            return;
        }
        placeholders.forEach((el) => {
            const materialId = el.getAttribute('data-material-id');
            if (!materialId || !GUID_PATTERN.test(materialId)) {
                return;
            }
            const filename = el.getAttribute('data-filename') || '';
            const request = {
                materialId,
                previewToken: props.previewToken,
                cacheVersion: props.pdfCacheVersion,
                fileName: filename,
            };
            const wrapper = createPdfCanvasPreviewElement();
            el.replaceWith(wrapper);
            canvasPreviews.add(renderPdfCanvasPreview(wrapper, request));
        });
    };
    const cancel = () => {
        disposeCanvasPreviews();
    };
    return { render, cancel };
}
function createPdfCanvasPreviewElement() {
    const wrapper = document.createElement('div');
    wrapper.className = 'pdf-inline-preview-shell';
    return wrapper;
}
//# sourceMappingURL=RichText.js.map